import React from "react";
import { GalleryVertical, Wrench } from "lucide-react";
import { MobileTabNavigationProps } from "@/app/types/ui.types";

export const MobileTabNavigation: React.FC<MobileTabNavigationProps> = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="flex border-b border-stone-200 shrink-0">
      <button
        onClick={() => setActiveTab("details")}
        className={`flex-1 p-3 font-semibold text-sm transition-colors flex items-center justify-center gap-2 ${
          activeTab === "details"
            ? "border-b-2 border-amber-500 text-amber-600"
            : "text-stone-500"
        }`}
      >
        <Wrench size={16} /> Details & Customize
      </button>
      <button
        onClick={() => setActiveTab("gallery")}
        className={`flex-1 p-3 font-semibold text-sm transition-colors flex items-center justify-center gap-2 ${
          activeTab === "gallery"
            ? "border-b-2 border-amber-500 text-amber-600"
            : "text-stone-500"
        }`}
      >
        <GalleryVertical size={16} /> Gallery & Colors
      </button>
    </div>
  );
};
